import useCore from 'modules/reports/hooks/core'
import React, {MouseEventHandler} from 'react'
import useStyles from './ReportsSpreadsheet.styles'
import ReportsSpreadsheetHead from './Head'
import ReportsSpreadsheetBody from './Body'
import ReportsSpreadsheetContext, {
  ReportsSpreadsheetContextProps,
} from './ReportsSpreadsheet.context'
import ReportsSpreadsheetColumn from './Column'
import useChildrenProps from 'modules/reports/hooks/childrenProps'

type Props = {
  prefix: string
  children: React.ReactNode
  data: any[]
  sort: string
  onNewColumn?: MouseEventHandler
}

function ReportsSpreadsheet(props: Props) {
  const {prefix, children, data, sort, onNewColumn} = props
  const classes = useStyles()
  const {p} = useCore('reports', 'components', 'Spreadsheet')
  const [columns] = useChildrenProps(children, ReportsSpreadsheetColumn)

  function handleSort() {}

  const contextValue: ReportsSpreadsheetContextProps = {
    onSort: handleSort,
    columns,
    data,
    sort,
    onNewColumn,
    prefix,
  }

  return (
    <ReportsSpreadsheetContext.Provider value={contextValue}>
      <table className={classes.root} data-testid={p()}>
        <ReportsSpreadsheetHead />
        <ReportsSpreadsheetBody />
      </table>
    </ReportsSpreadsheetContext.Provider>
  )
}

export default ReportsSpreadsheet
